import styled from 'styled-components';

import CircleButton from 'basics/buttons/CircleButton';

import { contentWithSidebar, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const MainBlock = styled.main`
    flex: 1 0 auto;
    background-color: ${COLORS.gray50};
    z-index: 1;
`;

export const BackButtonWrapper = styled.div`
    ${contentWithSidebar};
    padding-left: 4rem;
    margin-top: 6.8rem;
`;

export const BackButton = styled(CircleButton)`
    margin-bottom: 3.2rem;
`;

export const MarketSection = styled.section<{ $smallTopPadding?: boolean }>`
    ${contentWithSidebar};
    padding-top: ${({ $smallTopPadding }) => ($smallTopPadding ? '2rem' : '2.8rem')};
    padding-left: 4rem;
    width: 100%;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    background-color: ${COLORS.white};
    border-radius: 0.5rem;
    padding: 4.1rem 3.7rem;

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem;
    `}
`;

export const Divider = styled.div`
    border-top: 0.1rem solid ${COLORS.gray100};
    margin: 4rem 0;
    height: 0.1rem;
    width: 100%;
`;

export const MarketIdentityLoading = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const RewardsUnavailableWarning = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;
    width: 100%;
    min-height: 5.2rem;
    margin-top: 4rem;
    padding: 1.6rem;
    box-sizing: border-box;
    border-radius: 0.6rem;
    background: ${COLORS.gray50};
    color: ${COLORS.textSecondary};
    font-size: 1.4rem;
    line-height: 2rem;

    span {
        opacity: 0.7;
    }

    > span:first-child {
        flex-shrink: 0;
        font-size: 1.8rem;
        line-height: 2rem;
    }

    strong {
        font-weight: 700;
    }
`;
